import AppRouter from "./router/AppRouter";
import { StoreProvider } from "./context/StoreContext";

function App() {
  return (
    <StoreProvider>
      <AppRouter />
    </StoreProvider>
  );
}

export default App;